// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cmOWH","icon":"styles_icon__2lCGp"};